<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- Users -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="card-title">
                  <b-button
                    variant="primary"
                    class="btn btn-label btn-primary float-right"
                    v-b-modal.modal_addField
                    ><i class="bx bx-plus label-icon"></i>Add Field</b-button
                  >

                  <!-- Had to add inline styles, something is overriding the <style> tags - Kiefer -->
                  <b-button
                    style="margin:0px 20px 0px 20px"
                    @click="changedDraggableFields"
                    variant="primary"
                    class="btn btn-label btn-primary float-right"
                    ><i class="bx bx-save label-icon"></i>Save Safety
                    Form</b-button
                  >

                  <div class="col-3 float-right">
                    <v-select
                      @input="getFields"
                      :options="formsList"
                      label="name"
                      v-model="selectedForm"
                    ></v-select>
                  </div>
                  <b-modal
                    id="modal_addField"
                    title="Add Field"
                    title-class="font-18"
                    ok-title="Add Field"
                    @ok="addField"
                  >
                    <div class="mb-4">
                      <div class="form-group">
                        <label id="lbl_addField_name"
                          >Name <i class="bx bxs-help-circle"></i
                        ></label>
                        <b-tooltip target="lbl_addField_name"
                          >The name is a unique identifier for the field. This
                          is not shown anywhere on the mobile or web
                          application</b-tooltip
                        >
                        <b-form-input
                          placeholder="Name..."
                          v-model="addField_name"
                          :class="{
                            'is-invalid': addField_errors.nameError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="addField_errors.nameError"
                          class="invalid-feedback"
                        >
                          <span>{{ addField_errors.nameMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label id="lbl_addField_label"
                          >Label <i class="bx bxs-help-circle"></i
                        ></label>
                        <b-tooltip target="lbl_addField_label"
                          >The label is the text that is shown above the form
                          field in the web app and mobile app</b-tooltip
                        >
                        <b-form-input
                          placeholder="Label..."
                          v-model="addField_label"
                          :class="{
                            'is-invalid': addField_errors.labelError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="addField_errors.labelError"
                          class="invalid-feedback"
                        >
                          <span>{{ addField_errors.labelMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 mt-lg-0 mb-4">
                      <div class="form-group">
                        <label id="lbl_addField_type"
                          >Type <i class="bx bxs-help-circle"></i
                        ></label>
                        <b-tooltip target="lbl_addField_type"
                          >The field type will determine how the field looks and
                          what values will be allowed to be inputted in
                          it.</b-tooltip
                        >
                        <v-select
                          :options="fieldTypes"
                          label="position"
                          v-model="addField_selectedType"
                          :class="{
                            'is-invalid ddl-is-invalid':
                              addField_errors.typeError,
                          }"
                        ></v-select>
                        <div
                          v-if="addField_errors.typeError"
                          class="invalid-feedback"
                        >
                          <span>{{ addField_errors.typeMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="addField_selectedType == 'dropdown'"
                      class="mt-4 mt-lg-0 mb-4"
                    >
                      <div class="form-group">
                        <label id="lbl_addField_collection"
                          >Collection <i class="bx bxs-help-circle"></i
                        ></label>
                        <b-tooltip target="lbl_addField_collection"
                          >Each dropdown field must have a collection of
                          options/items associated to it. These collections can
                          be created and managed in the "Users & App Data"
                          page.</b-tooltip
                        >
                        <v-select
                          :options="collections"
                          label="collections"
                          v-model="addField_selectedCollection"
                          :class="{
                            'is-invalid ddl-is-invalid':
                              addField_errors.collectionErorr,
                          }"
                        ></v-select>
                        <div
                          v-if="addField_errors.collectionErorr"
                          class="invalid-feedback"
                        >
                          <span>{{ addField_errors.colelctionMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 mt-lg-0 mb-4">
                      <div class="form-group">
                        <b-form-checkbox
                          v-model="addField_required"
                          value="true"
                          unchecked-value="false"
                          class="custom-checkbox custom-control-right"
                          checked
                          >Field required
                          <i
                            id="lbl_addField_required"
                            class="bx bxs-help-circle"
                          ></i
                        ></b-form-checkbox>
                        <b-tooltip target="lbl_addField_required"
                          >If this value is unchecked, then the user will not be
                          required to fill out this field when entering a
                          time</b-tooltip
                        >
                      </div>
                    </div>
                  </b-modal>
                  <b-modal
                    id="modal_editField"
                    title="Edit Field"
                    title-class="font-18"
                    ok-title="Submit"
                    @ok="submitEditField"
                  >
                    <div class="mb-4">
                      <div class="form-group">
                        <label id="lbl_editField_name"
                          >Name <i class="bx bxs-help-circle"></i
                        ></label>
                        <b-tooltip target="lbl_editField_name"
                          >The name is a unique identifier for the field. This
                          is not shown anywhere on the mobile or web
                          application. This field cannot be edited.</b-tooltip
                        >
                        <b-form-input
                          disabled
                          placeholder="Name..."
                          v-model="editField_name"
                          :class="{
                            'is-invalid': editField_errors.nameError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="editField_errors.nameError"
                          class="invalid-feedback"
                        >
                          <span>{{ editField_errors.nameMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                      <div class="form-group">
                        <label id="lbl_editField_label"
                          >Label <i class="bx bxs-help-circle"></i
                        ></label>
                        <b-tooltip target="lbl_editField_label"
                          >The label is the text that is shown above the form
                          field in the web app and mobile app</b-tooltip
                        >
                        <b-form-input
                          placeholder="Label..."
                          v-model="editField_label"
                          :class="{
                            'is-invalid': editField_errors.labelError,
                          }"
                        ></b-form-input>
                        <div
                          v-if="editField_errors.labelError"
                          class="invalid-feedback"
                        >
                          <span>{{ editField_errors.labelMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 mt-lg-0 mb-4">
                      <div class="form-group">
                        <label id="lbl_editField_type"
                          >Type <i class="bx bxs-help-circle"></i
                        ></label>
                        <b-tooltip target="lbl_editField_type"
                          >The field type will determine how the field looks and
                          what values will be allowed to be inputted in
                          it.</b-tooltip
                        >
                        <v-select
                          :options="fieldTypes"
                          label="types"
                          v-model="editField_selectedType"
                          :class="{
                            'is-invalid ddl-is-invalid':
                              editField_errors.typeError,
                          }"
                        ></v-select>
                        <div
                          v-if="editField_errors.typeError"
                          class="invalid-feedback"
                        >
                          <span>{{ editField_errors.typeMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="editField_selectedType == 'dropdown'"
                      class="mt-4 mt-lg-0 mb-4"
                    >
                      <div class="form-group">
                        <label id="lbl_editField_collection"
                          >Collection <i class="bx bxs-help-circle"></i
                        ></label>
                        <b-tooltip target="lbl_editField_collection"
                          >Each dropdown field must have a collection of
                          options/items associated to it. These collections can
                          be created and managed in the "Users & App Data"
                          page.</b-tooltip
                        >
                        <v-select
                          :options="collections"
                          label="collections"
                          v-model="editField_selectedCollection"
                          :class="{
                            'is-invalid ddl-is-invalid':
                              editField_errors.collectionErorr,
                          }"
                        ></v-select>
                        <div
                          v-if="editField_errors.collectionErorr"
                          class="invalid-feedback"
                        >
                          <span>{{ editField_errors.colelctionMessage }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 mt-lg-0 mb-4">
                      <div class="form-group">
                        <b-form-checkbox
                          v-model="editField_required"
                          value="true"
                          unchecked-value="false"
                          class="custom-checkbox custom-control-right"
                          checked
                          >Field required
                          <i
                            id="lbl_editField_required"
                            class="bx bxs-help-circle"
                          ></i
                        ></b-form-checkbox>
                        <b-tooltip target="lbl_editField_required"
                          >If this value is unchecked, then the user will not be
                          required to fill out this field when entering a
                          time</b-tooltip
                        >
                      </div>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-8">
                <div class="row mt-4">
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    ></div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    ></div>
                  </div>
                  <!-- End search -->
                </div>

                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table-simple ref="table">
                    <b-thead>
                      <b-th></b-th>
                      <b-th>Edit</b-th>

                      <b-th>Name</b-th>
                      <b-th>Label</b-th>
                      <b-th>Type</b-th>
                      <b-th>Collection</b-th>
                      <b-th>Required</b-th>
                    </b-thead>

                    <draggable
                      handle=".handle"
                      :class="{ [`cursor-grabbing`]: dragging === true }"
                      v-model="formItemsTableData"
                      @start="dragging = true"
                      @end="dragging = false"
                      @change="dragDropMoved = true"
                      tag="tbody"
                    >
                      <b-tr
                        v-for="(element, index) in formItemsTableData"
                        :key="element.id"
                      >
                        <b-td
                          ><i class="handle bx bx-grid-horizontal"></i
                        ></b-td>
                        <b-td>
                          <b-dropdown variant="primary" size="sm">
                            <template v-slot:button-content>
                              <i class="mdi mdi-chevron-down"></i>
                            </template>
                            <b-dropdown-item
                              v-b-modal.modal_editField
                              @click="
                                editField(
                                  index,
                                  element.edit,
                                  element.name,
                                  element.label,
                                  element.type,
                                  element.required,
                                  element.collection
                                )
                              "
                              ><i class="bx bx-pencil mr-2 tableIcons"></i
                              >Edit</b-dropdown-item
                            >
                            <b-dropdown-item @click="cloneField(index)"
                              ><i class="bx bx-copy-alt mr-2 tableIcons"></i
                              >Clone Field</b-dropdown-item
                            >
                            <b-dropdown-item @click="deleteField(element.edit)"
                              ><i class="bx bx-trash mr-2 tableIcons"></i
                              >Delete</b-dropdown-item
                            ></b-dropdown
                          ></b-td
                        >

                        <b-td>{{ element.name }}</b-td>
                        <b-td>{{ element.label }}</b-td>
                        <b-td>{{ element.type }}</b-td>
                        <b-td>{{ element.collection }}</b-td>
                        <b-td>{{ element.required }}</b-td>
                      </b-tr>
                    </draggable>
                  </b-table-simple>
                </div>

                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-right"
                    ></div>
                  </div>
                </div>
              </div>
              <!--/Row-->
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from 'vue';
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import routes from '../../../routes.js';
import Swal from 'sweetalert2';
import VueToast from 'vue-toast-notification';
import draggable from 'vuedraggable';
// Import one of the available themes
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);

import {
  getSafetyFormFields,
  getFieldTypes,
  getCompanyCollections,
} from '../helper/dbHelpers.js';
import { firestore } from 'firebase';

export default {
  page: {
    title: 'Edit Safety Form',
    meta: [{ name: 'Edit Safety Form', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    draggable,
  },
  data() {
    return {
      showSavePopup: false,
      hasBeenEdited: false,
      saveButtonClicked: false,
      addedItemToTable: false,
      deletedItemFromTable: false,
      dragDropMoved: false,
      dragging: false,
      title: 'Edit Safety Form',
      name: 'Editm Safety Form',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'Edit Safety Form',
          href: '/production/safety',
          active: true,
        },
      ],
      routes: routes,
      formItemsPerPage: 10,
      formItemsTotalRows: 1,
      formItemsCurrentPage: 1,
      formItemsPageOptions: [10, 25, 50, 100],
      formItemsFilter: null,
      formItemsFilterOn: [],
      formItemsSortBy: 'order',
      formItemsSortDesc: false,
      formItemsFields: [
        { key: 'edit', sortable: false },
        { key: 'order', sortable: true },
        { key: 'name', sortable: true },
        { key: 'label', sortable: true },
        { key: 'type', sortable: true },
        { key: 'collection', sortable: true },
        { key: 'required', sortable: true },
      ],
      formItemsTableData: [],
      addField_name: null,
      addField_label: null,
      addField_type: null,
      addField_required: null,
      addField_selectedType: [],
      addField_selectedCollection: [],
      addField_errors: {
        nameError: false,
        nameMessage: null,
        labelError: false,
        labelMessage: null,
        typeError: false,
        typeMessage: null,
        collectionErorr: false,
        colelctionMessage: null,
      },
      editField_index: null,
      editField_order: null,
      editField_name: null,
      editField_label: null,
      editField_required: null,
      editField_selectedType: [],
      editField_selectedCollection: [],
      editField_errors: {
        nameError: false,
        nameMessage: null,
        labelError: false,
        labelMessage: null,
        typeError: false,
        typeMessage: null,
        collectionErorr: false,
        colelctionMessage: null,
      },
      fieldTypes: [],
      collections: [],
      selectedForm: {},
      formsList: [],
    };
  },
  watch: {
    saveButtonClicked() {
      this.swalPopupBooleanHandler();
    },
    dragDropMoved() {
      this.swalPopupBooleanHandler();
    },
    addedItemToTable() {
      this.swalPopupBooleanHandler();
    },
    deletedItemFromTable() {
      this.swalPopupBooleanHandler();
    },
    hasBeenEdited() {
      this.swalPopupBooleanHandler();
    },
  },
  methods: {
    swalPopupBooleanHandler() {
      if (
        (this.dragDropMoved ||
          this.addedItemToTable ||
          this.deletedItemFromTable ||
          this.hasBeenEdited) &&
        !this.saveButtonClicked
      ) {
        this.showSavePopup = true;
      } else {
        this.showSavePopup = false;
      }
    },
    preventPageRefresh: function(e) {
      if (this.showSavePopup) {
        e.preventDefault();
        e.stopPropagation();
        e.returnValue = '';
      }
    },
    validateAddField: function() {
      let flag = true;
      //check to make sure the name isn't empty and the name is unique
      if (
        this.formItemsTableData.length >= 0 &&
        this.formItemsTableData.find((o) => o.name == this.addField_name) !=
          undefined
      ) {
        this.addField_errors.nameError = true;
        this.addField_errors.nameMessage = 'The name field must be unique.';
        flag = false;
      } else if (
        this.addField_name == null ||
        this.addField_name.trim() == ''
      ) {
        this.addField_errors.nameError = true;
        this.addField_errors.nameMessage = 'Value cannot be empty.';
        flag = false;
      } else if (this.addField_name.includes(' ')) {
        this.addField_errors.nameError = true;
        this.addField_errors.nameMessage = 'Value cannot contain spaces.';
        flag = false;
      } else if (
        ['~', '*', '/', '[', ']', '.'].some((v) => this.addField_name.includes(v))
      ) {
        this.addField_errors.nameError = true;
        this.addField_errors.nameMessage = `The name field cannot contain the '~', '*', '/', '.', '[', or ']' characters.`;
        flag = false;
      } else {
        this.addField_errors.nameError = false;
        this.addField_errors.nameMessage = null;
      }
      //check to make sure the label value isn't empty
      if (this.addField_label == null || this.addField_label.trim() == '') {
        this.addField_errors.labelError = true;
        this.addField_errors.labelMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.addField_errors.labelError = false;
        this.addField_errors.labelMessage = null;
      }
      //check to make sure the type is selected has been selected.
      if (
        this.addField_selectedType == null ||
        this.addField_selectedType.length == 0
      ) {
        this.addField_errors.typeError = true;
        this.addField_errors.typeMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        //if the selected field type is dropdown, then we need to ensure that the user has selected a collection.
        this.addField_errors.typeError = false;
        this.addField_errors.tyoeMessage = null;
        if (
          this.addField_selectedType == 'dropdown' &&
          (this.addField_selectedCollection == undefined ||
            this.addField_selectedCollection.length == 0)
        ) {
          this.addField_errors.collectionErorr = true;
          this.addField_errors.colelctionMessage =
            'A collection must be selected';
          flag = false;
        } else {
          this.addField_errors.collectionErorr = false;
          this.addField_errors.colelctionMessage = null;
        }
      }
      return flag;
    },
    addField: function(bvModalEvt) {
      if (this.validateAddField()) {
        //add the new form to the array.
        let field = {
          edit: this.formItemsTableData.length,
          name: this.addField_name,
          type: this.addField_selectedType,
          label: this.addField_label,
          required: Boolean(this.addField_required),
          // order: this.formItemsTotalRows,
          order: this.formItemsTableData.length,
        };

        if (
          this.addField_selectedCollection != null &&
          this.addField_selectedCollection.length > 0 &&
          this.addField_selectedType == 'dropdown'
        ) {
          field.collection = this.addField_selectedCollection;
        }
        //append the new object to the field array. This way it will be added to the db and the table will be updated.
        this.formItemsTableData.push(field);
        this.addedItemToTable = true;
      } else {
        bvModalEvt.preventDefault();
      }
    },
    editField: function(index, order, name, label, type, required, collection) {
      this.editField_index = index;
      this.editField_order = order;
      this.editField_name = name;
      this.editField_label = label == null ? name : label;
      this.editField_selectedType = type;
      this.editField_required = required == null ? false : required;
      this.editField_selectedCollection = collection;
    },
    validateEditField: function() {
      let flag = true;
      //check to make sure the name isn't empty
      if (this.editField_name == null || this.editField_name.trim() == '') {
        this.editField_errors.nameError = true;
        this.editField_errors.nameMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.editField_errors.nameError = false;
        this.editField_errors.nameMessage = null;
      }
      //check to make sure the label value isn't empty
      if (this.editField_label == null || this.editField_label.trim() == '') {
        this.editField_errors.labelError = true;
        this.editField_errors.labelMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        this.editField_errors.labelError = false;
        this.editField_errors.labelMessage = null;
      }
      //check to make sure the type is selected has been selected.
      if (this.editField_selectedType.length == 0) {
        this.editField_errors.typeError = true;
        this.editField_errors.typeMessage = 'Value cannot be empty.';
        flag = false;
      } else {
        //if the selected field type is dropdown, then we need to ensure that the user has selected a collection.
        this.editField_errors.typeError = false;
        this.editField_errors.typeMessage = null;
        if (
          this.editField_selectedType == 'dropdown' &&
          (this.editField_selectedCollection == undefined ||
            this.editField_selectedCollection.length == 0)
        ) {
          this.editField_errors.collectionErorr = true;
          this.editField_errors.colelctionMessage =
            'A collection must be selected';
          flag = false;
        } else {
          this.editField_errors.collectionErorr = false;
          this.editField_errors.colelctionMessage = null;
        }
      }

      return flag;
    },
    submitEditField: function(bvModalEvt) {
      if (this.validateEditField()) {
        //find the field that we are editing and change it to the edit values.
        let required = false;

        if (this.editField_required.toString() == 'true') {
          required = true;
        }
        const itemIndex = this.formItemsTableData.findIndex(
          (o) => o.edit == this.editField_order
        );

        this.formItemsTableData.splice(itemIndex, 1, {
          edit: this.editField_order,
          name: this.editField_name,
          type: this.editField_selectedType,
          label: this.editField_label,
          required: required,
          order: this.editField_order,
        });

        const tempArray = this.formItemsTableData;
        this.formItemsTableData = tempArray;
        if (
          this.editField_selectedCollection != null &&
          this.editField_selectedCollection.length > 0 &&
          this.editField_selectedType == 'dropdown'
        ) {
          this.formItemsTableData[
            itemIndex
          ].collection = this.editField_selectedCollection;
        }
        this.hasBeenEdited = true;
      } else {
        bvModalEvt.preventDefault();
      }
    },
    deleteField: function(index) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'This item will be deleted permanently',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Yes',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.deletedItemFromTable = true;
          const itemIndex = this.formItemsTableData.findIndex(
            (o) => o.order == index
          );
          this.formItemsTableData.splice(itemIndex, 1);
        }
      });

      // .then((result) => {
      //   if (result.value) {
      //     //remove the item from the array and then udpate the db with the new array.
      //     this.formItemsTableData = this.formItemsTableData.filter(function(
      //       obj
      //     ) {
      //       return obj.edit !== index;
      //     });
      //     firestore()
      //       .collection('organizations')
      //       .doc(sessionStorage.getItem('org'))
      //       .collection('safetyForms')
      //       .doc(this.selectedForm.edit)
      //       .update({
      //         inputs: this.formItemsTableData,
      //       })
      //       .then(() => {
      //         Swal.fire(
      //           'Success!',
      //           'Form field successfully deleted.',
      //           'success'
      //         );
      //         console.log('After Deleted Table Data', this.formItemsTableData);
      //         this.formItemsTotalRows += -1;
      //       })
      //       .catch(() => {
      //         Swal.fire(
      //           'Error!',
      //           'An error was encounted when deleteing the record.',
      //           'error'
      //         );
      //       });
      //   }
      // });
    },
    changedDraggableFields: function() {
      this.saveButtonClicked = true;

      firestore()
        .collection('organizations')
        .doc(sessionStorage.getItem('org'))
        .collection('safetyForms')
        .doc(this.selectedForm.edit)
        .update({
          inputs: this.formItemsTableData,
        })
        .then(() => {
          console.log('Successfully Saved Form');
          Vue.$toast.open({
            message: 'Successfully Saved Form',
            type: 'success',
            duration: 4000,
            position: 'top-right',
          });
        })
        .catch(() => {
          Swal.fire(
            'Error!',
            'An error was encounted when adding the record.',
            'error'
          );
          //research the fields if there was an error.
          this.getFields();
        });
    },
    arrayMove: function(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
      //update the order values, so they are displayed correctly in the table.
      arr[fromIndex].order = fromIndex;
      arr[toIndex].order = toIndex;
      return arr;
    },
    getFields: function() {
      this.formItemsTableData = [];

      getSafetyFormFields(this.selectedForm.edit)
        .then((doc) => {
          let formElements = [];

          if (doc.exists) {
            //the form may not have fields yet, so need to handle that.
            if (doc.data().inputs != undefined) {
              formElements = doc.data().inputs;
              this.formItemsTotalRows = doc.data().inputs.length;

              //loop through the objects and we will be assigning the index to the object as well.
              formElements.forEach((element, index) => {
                (element.edit = index), (element.order = index);
              });
            }

            //set the table data to the array of elements
            this.formItemsTableData = formElements;
          } else {
            Swal.fire(
              'Error!',
              `This form doesn't exist. If this is an error, contact support.`,
              'error'
            );
          }
        })
        .catch((err) => {
          Swal.fire(
            'Error!',
            `An error was encountered while retreiving the form fields: ${err}`,
            'error'
          );
        });
    },
    populateCollections: function() {
      getCompanyCollections()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.collections.push(doc.data().name);
          });
        })
        .catch((err) => {
          console.log(err);
          Swal.fire(
            'Error!',
            'An error was encountered while retreiving the list of collections',
            'error'
          );
        });
    },
    populateFieldTypes: function() {
      getFieldTypes()
        .then((querySnapshot) => {
          //itterate the snapshot and populate the types array.
          let types = [];
          querySnapshot.forEach((doc) => {
            types.push(doc.data().name);
          });
          this.fieldTypes = types;
        })
        .catch(() => {
          Swal.fire(
            'Error!',
            'An error was encountered while retreiving the field types',
            'error'
          );
        });
    },
    cloneField: function(index) {
      try {
        //add a copt of the item in the index to the end of the array.
        let tempField = Object.assign({}, this.formItemsTableData[index]);
        tempField.name = tempField.name + ' - copy';
        tempField.label = tempField.name;
        tempField.edit = this.formItemsTableData.length;
        tempField.order = this.formItemsTableData.length;
        this.formItemsTableData.push(tempField);
      } catch (err) {
        Vue.$toast.open({
          message: `Error cloning field: ${err}`,
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
  },
  mounted() {
    this.formsList = this.$route.params.forms;
    //setting the form selection dropdown at the top of the page.
    this.selectedForm = {
      name: this.$route.params.name,
      edit: this.$route.params.id,
    };

    //get the fields for the form that is selected.
    this.getFields();
    this.populateFieldTypes();
    this.populateCollections();
  },
  created() {
    //Removes event listener after navigating away from page to prevent
    //popup from appearing on other pages
    window.onunload = function() {
      document.body.removeEventListener(
        'beforeunload',
        this.preventPageRefresh
      );
      return;
    };

    //Prevents refresh of page
    window.addEventListener('beforeunload', this.preventPageRefresh);
  },
  // Creates popup that asks user if they want to save their changes
  // before navigating to a different page
  beforeRouteLeave(to, from, next) {
    if (this.showSavePopup) {
      Swal.fire({
        title:
          'Do you want to save your changes? Any unsaved changes will be deleted.',

        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Save Changes',
        cancelButtonText: 'Leave Page',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.changedDraggableFields();
          next();
        } else {
          this.showSavePopup = false;
          next();
        }
      });
    } else {
      next();
    }
  },
};
</script>
<style scoped>
.handle:hover {
  cursor: pointer;
}
</style>
